module.exports = __webpack_public_path__ + "img/_w_.5621a77a.svg";